import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-16 bg-white border-t border-gray-100" data-id="element-184">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-185">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 border-2 md:border-4 border-green-100 rounded-2xl p-5 md:p-12" data-id="element-186">
          <div className="flex-shrink-0" data-id="element-187">
            <div className="w-20 h-20 md:w-32 md:h-32 bg-green-50 rounded-full flex items-center justify-center border-4 border-green-200" data-id="element-188">
              <Shield className="w-10 h-10 md:w-16 md:h-16 text-green-600" data-id="element-189" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-190">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-191">
              Garantía de 120 Días: "
              <span className="text-green-700 highlight-gold" data-id="element-192">
                ÁMALO O DÉJALO
              </span>
              " — <span className="underline-emphasis" data-id="element-193">100% Satisfacción</span>
            </h2>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-194">
              Si este no es el{' '}
              <span className="font-bold text-gray-900" data-id="element-195">
                recurso visual bíblico más completo
              </span>{' '}
              que hayas visto jamás, simplemente envíame un correo electrónico y
              te devolveré el{' '}
              <span className="font-bold text-green-700" data-id="element-196">
                100% de tu dinero
              </span>
              .{' '}
              <span className="italic font-medium text-gray-900" data-id="element-197">
                Sin preguntas.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}